export enum MonthFormat {
  SHORT = 'short',
  LONG = 'long',
}
